<template>
  <div class="archive-manager">
    <div class="archive-card">
      <div class="archive-header">
        <h3>Saved matches</h3>
        <button class="btn secondary" @click="handleClose">Close</button>
      </div>
      <div v-if="entries.length" class="archive-list">
        <div v-for="entry in entries" :key="entry.key" class="archive-row">
          <div class="archive-main">
              <div class="archive-title-row">
                <span class="archive-badge" :class="entry.finished ? 'finished' : 'unfinished'">
                  {{ entry.finished ? 'Finished' : 'In progress' }}
                </span>
                <div class="archive-title">
                  {{ entry.title || entry.label || 'Saved match' }}
                </div>
              </div>
            <div class="archive-meta">
              <span v-if="entry.date">Date: {{ entry.date }}</span>
              <span v-if="entry.competition">Comp: {{ entry.competition }}</span>
              <span v-if="entry.finished">
                Result: {{ entry.winner || 'finished' }}
              </span>
              <span v-if="entry.savedAt">Saved: {{ formatSavedAt(entry.savedAt) }}</span>
            </div>
          </div>
          <div class="archive-actions">
            <button class="btn secondary" @click="handleRestore(entry.key)">Restore</button>
            <button class="btn destructive" @click="handleDelete(entry.key)">Delete</button>
          </div>
        </div>
      </div>
      <p v-else class="empty-text">No saved matches yet.</p>
    </div>
  </div>
</template>

<script>
import { getArchiveIndex, deleteArchive } from '../storage.js';

export default {
  name: 'ArchiveManager',
  data() {
    return {
      entries: []
    };
  },
  mounted() {
    this.loadEntries();
  },
  methods: {
    loadEntries() {
      this.entries = getArchiveIndex();
    },
    formatSavedAt(value) {
      const date = new Date(value);
      if (Number.isNaN(date.getTime())) {
        return value;
      }
      return date.toLocaleString();
    },
    handleClose() {
      this.$emit('close');
    },
    handleRestore(key) {
      this.$emit('restore', key);
    },
    handleDelete(key) {
      const confirmed = window.confirm('Delete this saved match? This cannot be undone.');
      if (!confirmed) {
        return;
      }
      deleteArchive(key);
      this.loadEntries();
    }
  }
};
</script>

<style scoped lang="scss">
.archive-manager {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.4);
  z-index: 1200;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
}

.archive-card {
  background: var(--white);
  color: var(--grey-900);
  border-radius: 10px;
  width: min(860px, 96vw);
  max-height: 80vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-shadow: 0 12px 30px var(--grey-1000);
}

.archive-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  border-bottom: 1px solid var(--grey-25);
  background: var(--grey-5);
}

.archive-list {
  padding: 12px 16px;
  overflow: auto;
}

.archive-main {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.archive-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 10px 0;
  border-bottom: 1px solid var(--grey-25);
}

.archive-row:last-child {
  border-bottom: none;
}

.archive-title {
  font-weight: 700;
  margin-bottom: 4px;
}

.archive-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  font-size: 12px;
  color: var(--grey-400);
}

.archive-title-row {
  display: flex;
  align-items: center;
  gap: 8px;
}
.archive-badge {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 10px;
  font-weight: 700;
  color: var(--white);
}
.archive-badge.finished {
  background: var(--green-100);
  color: var(--green-700);
}
.archive-badge.unfinished {
  background: var(--grey-50);
  color: var(--grey-600);
}

.archive-actions {
  display: flex;
  gap: 8px;
}

.empty-text {
  padding: 24px;
  text-align: center;
  color: var(--grey-400);
}
</style>
